import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, Printer, MessageCircle } from 'lucide-react';
import api from '../lib/api';
import Receipt from '../components/Receipt';
import { TombolWa } from '../components/KirimWa';

const SIZES = [
  { v: 'a4', l: 'A4' },
  { v: '80mm', l: 'Thermal 80mm' },
  { v: '58mm', l: 'Thermal 58mm' },
];

export default function ReceiptPage() {
  const { id } = useParams();
  const [tx, setTx] = useState(null);
  const [settings, setSettings] = useState(null);
  const [size, setSize] = useState('a4');

  useEffect(() => {
    api.get(`/transactions/${id}`).then((r) => setTx(r.data));
    api.get('/settings').then((r) => setSettings(r.data));
  }, [id]);

  if (!tx) return <p className="text-sm text-muted-foreground py-16 text-center">Memuat nota…</p>;

  return (
    <div className="space-y-5" data-testid="receipt-page">
      <div className="flex flex-wrap items-center justify-between gap-3 print:hidden">
        <div className="flex items-center gap-3">
          <Link to="/nota" data-testid="back-to-receipts" className="p-2 rounded-full bg-white border border-gold/20 text-emerald">
            <ArrowLeft size={18} />
          </Link>
          <h1 className="font-display text-2xl md:text-3xl text-ink tracking-tight">Nota {tx.transaction_number}</h1>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <div className="flex gap-1.5" data-testid="receipt-size-toggle">
            {SIZES.map((s) => (
              <button
                key={s.v}
                data-testid={`receipt-size-${s.v}`}
                onClick={() => setSize(s.v)}
                className={`rounded-full px-3.5 py-2 text-xs font-semibold transition-colors ${
                  size === s.v ? 'bg-emerald text-white' : 'bg-white border border-gold/20 text-muted-foreground'
                }`}
              >
                {s.l}
              </button>
            ))}
          </div>
          <button
            data-testid="print-receipt-button"
            onClick={() => window.print()}
            className="inline-flex items-center gap-2 rounded-full bg-emerald text-white px-5 py-2.5 text-sm font-semibold hover:bg-emerald-light transition-colors"
          >
            <Printer size={15} /> Cetak Nota
          </button>
          <TombolWa
            target={{ kind: 'order', id: tx.id }}
            testid="receipt-whatsapp-button"
            title="Kirim pesan WhatsApp ke customer"
            className="inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white px-5 py-2.5 text-sm font-semibold hover:opacity-90 transition-opacity"
          >
            <MessageCircle size={15} /> WhatsApp
          </TombolWa>
        </div>
      </div>

      <div className="flex justify-center">
        <Receipt tx={tx} settings={settings} size={size} />
      </div>
    </div>
  );
}
